module.exports = __webpack_public_path__ + "media/7.87603a16.mp3";